import { isRestrictedTrailerUse } from '@ourbranch/lookups';
import type { TrailerDetails } from '@ourbranch/schema-types/appsync';

import { defineInternalTask } from '../../../config/types';
import { internalTasks, reviewTeams } from '../../../config/constants';

import { baseBindState, formatTrailerData } from './lib/helpers';

/**
 * Flag policies bound with a trailer whose primary usage is something other than
 * Pleasure (Business / Residence / Rental). UW Ops reviews these to confirm
 * eligibility — Residence in particular (member living in the trailer full-time)
 * may be ineligible. We flag for review rather than reject so policies bind with
 * honest answers instead of agents reverting to "Pleasure". Issue #24533, mirrors
 * the car business-use flow from #23948 / PR #24597.
 */
export const trailerWithRestrictedUse = defineInternalTask({
  taskName: internalTasks.TrailerWithRestrictedUse,
  config: {
    staffDisplayName: 'Trailer with Restricted Usage: review needed',
    reviewTeam: reviewTeams.uwOps,
    policyTypes: ['A'],
    enabled: true,
    trigger: ({ policy, offer }) => {
      const trailers = (offer?.quote?.trailers || []).filter((t): t is TrailerDetails => !!t);
      const restrictedTrailers = trailers.filter((trailer) => isRestrictedTrailerUse(trailer.primaryUse));
      if (restrictedTrailers.length === 0) {
        return null;
      }
      return {
        data: { trailersData: formatTrailerData(restrictedTrailers) },
        bindState: baseBindState(policy)
      };
    },
    description: ({ policyId, data }) =>
      `The following trailer(s) on ${policyId} were bound with restricted usage (Business/Residence/Rental):
${data.trailersData || 'N/A'}`
  }
});
